import React from "react";
import CreateExam from "../../../Components/Admin/Exam/CreateExam";
import ListExam from "../../../Components/Admin/Exam/ListExam";

const Exam = () => {
  return (
    <>
      <main className=" container flex-1 overflow-x-hidden overflow-y-auto">
        <div className="container mx-auto px-6 py-3">
          <h3 className="text-gray-700 text-3xl font-bold">Manage Exams</h3>
          <CreateExam />
          <hr />
          <div className="mt-3">
            <ListExam />
          </div>

          <div className="mt-8"></div>
        </div>
      </main>
    </>
  );
};

export default Exam;
